"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by pavel.arakelyan on 11/13/17.
 */
var RowType;
(function (RowType) {
    RowType[RowType["NEW"] = 0] = "NEW";
    RowType[RowType["SPECIFIED"] = 1] = "SPECIFIED"; // indicates that item for row is already specified
})(RowType = exports.RowType || (exports.RowType = {}));
//# sourceMappingURL=row-type.js.map